// extracted by mini-css-extract-plugin
export default {"wrapperInputs":"Range_wrapperInputs__uJDKO","antd":"Range_antd__3TF2t"};